export const CLINICAL_PATHWAYS = [
  {
    id: 'inversion',
    target: '#comparison',
    btnId: 'funnel-btn-comparison',
    title: 'Why Not Inversion?',
    subtitle: 'Zero stroke & ocular risk',
    tag: 'Safety Compare',
    accent: 'blue',
    icon: `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
      <path d="m9 12 2 2 4-4"/>
    </svg>`,
  },
  {
    id: 'hernia',
    target: '#calculator',
    btnId: 'funnel-btn-hernia',
    title: 'Herniated Disc Protocol',
    subtitle: 'L4–S1 angle calibrator',
    tag: 'Diagnostic Tool',
    accent: 'emerald',
    icon: `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <rect x="7" y="3" width="10" height="4" rx="2"/>
      <rect x="6" y="10" width="12" height="4" rx="2"/>
      <rect x="5" y="17" width="14" height="4" rx="2"/>
      <line x1="12" y1="7" x2="12" y2="10"/>
      <line x1="12" y1="14" x2="12" y2="17"/>
    </svg>`,
  },
  {
    id: 'sciatica',
    target: '#calculator',
    btnId: 'funnel-btn-sciatica',
    title: 'Sciatica & Nerve Root',
    subtitle: 'L4–S1 nerve decompression',
    tag: 'Sciatica Relief',
    accent: 'amber',
    icon: `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
    </svg>`,
  },
  {
    id: 'pediatric',
    target: '#pediatric-family',
    btnId: 'funnel-btn-pediatric',
    title: 'Kids & Scoliosis Care',
    subtitle: 'Ages 3–15 posture & growth',
    tag: 'Kids & Teens',
    accent: 'teal',
    icon: `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <circle cx="12" cy="7" r="4"/>
      <path d="M6 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2"/>
      <path d="M12 11v4"/>
    </svg>`,
  },
  {
    id: 'cervical',
    target: '#videos',
    btnId: 'funnel-btn-cervical',
    title: 'Cervical Neck Traction',
    subtitle: 'Glisson loop decompression',
    tag: 'Neck & Cervical',
    accent: 'blue',
    icon: `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <path d="M12 2v3"/>
      <circle cx="12" cy="9" r="3.5"/>
      <path d="M6 20c0-3.3 2.7-6 6-6s6 2.7 6 6"/>
      <path d="M9 13h6"/>
    </svg>`,
  },
  {
    id: 'athletes',
    target: '#athletes',
    btnId: 'funnel-btn-athletes',
    title: 'Athletic Recovery',
    subtitle: 'Axial compression relief',
    tag: 'Heavy Lifters',
    accent: 'teal',
    icon: `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <path d="M2 12h20"/>
      <rect x="4" y="6" width="3" height="12" rx="1"/>
      <rect x="17" y="6" width="3" height="12" rx="1"/>
      <line x1="1" y1="9" x2="1" y2="15"/>
      <line x1="23" y1="9" x2="23" y2="15"/>
    </svg>`,
  },
  {
    id: 'posture',
    target: '#gallery',
    btnId: 'funnel-btn-posture',
    title: 'Desk Worker Posture',
    subtitle: 'Thoracic & forward-head relief',
    tag: 'WFH & Posture',
    accent: 'indigo',
    icon: `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <rect x="2" y="3" width="20" height="14" rx="2"/>
      <line x1="8" y1="21" x2="16" y2="21"/>
      <line x1="12" y1="17" x2="12" y2="21"/>
    </svg>`,
  },
  {
    id: 'mounting',
    target: '#mounting',
    btnId: 'funnel-btn-mounting',
    title: 'Wall & Renter Setup',
    subtitle: '16" studs, masonry & stand',
    tag: 'Installation',
    accent: 'amber',
    icon: `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <rect x="3" y="3" width="18" height="18" rx="2"/>
      <line x1="9" y1="3" x2="9" y2="21"/>
      <line x1="15" y1="3" x2="15" y2="21"/>
      <circle cx="9" cy="8" r="1" fill="currentColor"/>
      <circle cx="9" cy="16" r="1" fill="currentColor"/>
      <circle cx="15" cy="8" r="1" fill="currentColor"/>
      <circle cx="15" cy="16" r="1" fill="currentColor"/>
    </svg>`,
  },
  {
    id: 'recovery',
    target: '#onboarding',
    btnId: 'funnel-btn-recovery',
    title: '30-Day Video Program',
    subtitle: 'Daily kinesitherapy routines',
    tag: 'Guided Rehab',
    accent: 'indigo',
    icon: `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <rect x="2" y="4" width="20" height="15" rx="3"/>
      <polygon points="10 8 16 11.5 10 15 10 8" fill="currentColor" fill-opacity="0.2"/>
      <line x1="8" y1="21" x2="16" y2="21"/>
      <line x1="12" y1="19" x2="12" y2="21"/>
    </svg>`,
  },
  {
    id: 'centers',
    target: '#centers',
    btnId: 'funnel-btn-centers',
    title: 'Kyiv Flagship Centers',
    subtitle: '30-yr clinic & 500k+ healed',
    tag: 'Official Clinic',
    accent: 'teal',
    icon: `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <path d="M3 21h18"/>
      <path d="M5 21V7l7-4 7 4v14"/>
      <path d="M9 18h6"/>
      <path d="M10 11h4"/>
      <path d="M12 9v4"/>
    </svg>`,
  },
  {
    id: 'patents',
    target: '#patents',
    btnId: 'funnel-btn-patents',
    title: 'Patents & Certifications',
    subtitle: 'MOH approved • 6 global patents',
    tag: 'Medical Patents',
    accent: 'emerald',
    icon: `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <circle cx="12" cy="8" r="6"/>
      <path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11"/>
    </svg>`,
  },
  {
    id: 'studies',
    target: '#blog',
    btnId: 'funnel-btn-studies',
    title: 'Clinical Trials & Data',
    subtitle: 'Since 1996 • 30-yr evidence',
    tag: 'Since 1996',
    accent: 'emerald',
    icon: `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
      <line x1="9" y1="7" x2="15" y2="7"/>
      <line x1="9" y1="11" x2="13" y2="11"/>
    </svg>`,
  },
];

export function renderFunnelsNav() {
  return `
    <nav class="funnels-nav-section" id="clinical-solutions-nav" aria-label="Clinical Solutions & Protocols">
      <div class="calc-container">
        <div class="funnels-nav-inner">
          
          <div class="funnels-header-row">
            <div class="funnels-header-title-group">
              <span class="funnels-eyebrow-pill">
                <span class="funnels-pulsing-dot" aria-hidden="true"></span>
                CLINICAL PATHWAYS
              </span>
              <h2 class="funnels-section-heading">Explore by Condition &amp; Need</h2>
            </div>
            <div class="funnels-header-meta">
              <span class="funnels-meta-badge">${CLINICAL_PATHWAYS.length} Evidence-Based Pathways</span>
            </div>
          </div>

          <div class="funnels-cards-grid" role="tablist" aria-label="Clinical pathways directory">
            ${CLINICAL_PATHWAYS.map((item, idx) => `
              <a 
                href="${item.target}" 
                class="funnel-pathway-card ${idx === 0 ? 'active' : ''}" 
                id="${item.btnId}"
                role="tab"
                aria-selected="${idx === 0 ? 'true' : 'false'}"
                data-target="${item.target}"
                title="${item.title}: ${item.subtitle}"
              >
                <div class="pathway-icon-box accent-${item.accent}">
                  ${item.icon}
                </div>
                <div class="pathway-content">
                  <div class="pathway-tag-row">
                    <span class="pathway-micro-tag">${item.tag}</span>
                  </div>
                  <div class="pathway-title">${item.title}</div>
                  <div class="pathway-subtitle">${item.subtitle}</div>
                </div>
                <div class="pathway-arrow" aria-hidden="true">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 18 15 12 9 6"/></svg>
                </div>
              </a>
            `).join('')}
          </div>

        </div>
      </div>
    </nav>
  `;
}

export function initFunnelsNav() {
  if (typeof document === 'undefined') return;
  const container = document.querySelector('.funnels-nav-section');
  if (!container) return;

  const cards = container.querySelectorAll('.funnel-pathway-card');
  if (!cards.length) return;

  let isClickScrolling = false;
  let clickScrollTimeout = null;

  function setActiveCard(targetHref) {
    cards.forEach(card => {
      const isMatch = card.getAttribute('href') === targetHref;
      card.classList.toggle('active', isMatch);
      card.setAttribute('aria-selected', isMatch ? 'true' : 'false');
    });
  }

  function handleNavigation(card, e) {
    const href = card.getAttribute('href');
    if (href && href.startsWith('#')) {
      const target = document.querySelector(href);
      if (target) {
        if (e) e.preventDefault();
        setActiveCard(href);

        isClickScrolling = true;
        clearTimeout(clickScrollTimeout);
        clickScrollTimeout = setTimeout(() => {
          isClickScrolling = false;
        }, 1000);

        const headerEl = document.getElementById('site-header');
        const headerOffset = headerEl ? headerEl.offsetHeight + 16 : 90;
        const currentY = window.pageYOffset || document.documentElement.scrollTop || 0;
        const targetY = target.getBoundingClientRect().top + currentY - headerOffset;

        window.scrollTo({
          top: Math.max(0, targetY),
          behavior: 'smooth'
        });

        if (window.history && window.history.pushState) {
          window.history.pushState(null, '', href);
        }
      }
    }
  }

  cards.forEach(card => {
    card.addEventListener('click', (e) => handleNavigation(card, e));
    card.addEventListener('keydown', (e) => {
      if (e.key === ' ' || e.key === 'Spacebar') {
        handleNavigation(card, e);
      }
    });
  });

  // Scrollspy via IntersectionObserver: highlight active pathway card as sections enter viewport
  if ('IntersectionObserver' in window) {
    const targets = CLINICAL_PATHWAYS.map(p => document.querySelector(p.target)).filter(Boolean);

    const observer = new IntersectionObserver((entries) => {
      if (isClickScrolling) return;

      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const id = `#${entry.target.id}`;
          setActiveCard(id);
        }
      });
    }, {
      rootMargin: '-20% 0px -55% 0px',
      threshold: 0.1
    });

    targets.forEach(target => observer.observe(target));
  }
}
